import { render, staticRenderFns } from "./BranchMenu.vue?vue&type=template&id=0875b37c&scoped=true&"
import script from "./BranchMenu.vue?vue&type=script&lang=ts&"
export * from "./BranchMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BranchMenu.vue?vue&type=style&index=0&id=0875b37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875b37c",
  null
  
)

export default component.exports